import React, { useContext } from "react";
import clsx from "clsx";
import { FaGripVertical } from "react-icons/fa";

import * as strings from "../../../strings";
import { translate, LocaleContext } from "../../../lib/util/LocaleUtils";

interface CompetitionCardProps {
	isEditable?: boolean;
	selected?: boolean;
	handleClick?: () => void;
	competition: any;
	isRaffle?: boolean;
	locale?: any;
	img?: React.ReactNode;
}

const CompetitionCard: React.FC<CompetitionCardProps> = ({
	isEditable,
	selected,
	handleClick,
	competition,
	isRaffle,
	img,
}) => {
	const localeContext = useContext(LocaleContext);

	return (
		<>
			<div
				className={"RewardsBuilder__competition-card"}
				onClick={handleClick}
				role={"button"}
			>
				<div className={"RewardsBuilder__competition-hero"}>
					{img || (
						<img
							src={competition.heroImageSrc || competition.heroImage}
							style={{ width: "100%" }}
							className={"RewardsBuilder__competition-hero-img"}
							alt={""}
						/>
					)}
				</div>
				<div className={"RewardsBuilder__competition-card-details"}>
					<h3
						className={clsx({ "--nameless": !competition.name })}
						key={competition.key}
					>
						{competition.name}
					</h3>
					{isRaffle && !selected && (
						<p>
							{competition.numberOfWinners || 1} Prizes to be won in this raffle
						</p>
					)}

					{selected && (
						<div className={"RewardsBuilder__competition-wireframe"}>
							<div
								className={"RewardsBuilder__competition-wireframe-countdown"}
							>
								<div
									className={
										"RewardsBuilder__competition-wireframe-countdown-item"
									}
								/>
								<div
									className={
										"RewardsBuilder__competition-wireframe-countdown-item"
									}
								/>
							</div>

							<div
								className={"RewardsBuilder__competition-wireframe-details"}
							/>
							<div className={"RewardsBuilder__competition-wireframe-entry"} />
						</div>
					)}

					{selected && isRaffle && (
						<div className={"RewardsBuilder__competition-description"}>
							<p
								dangerouslySetInnerHTML={{
									__html:
										competition.copy ||
										translate(
											strings.REWARDS_RAFFLE_EXPLANATION,
											localeContext.locale,
										),
								}}
							/>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default CompetitionCard;
